import React from 'react';
import PurchaseRequestList from '../../components/PurchaseRequest/PurchaseRequestList';

const PurchaseRequestListPage = () => {
  return <PurchaseRequestList />;
};

export default PurchaseRequestListPage;